import { useState, useEffect } from "react";
import { IconPrinter } from "@tabler/icons-react";
import print from "print-js";
import { getGroupName } from "./orders";
function Totals(props) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const items = getItems(props.orders, props.selectedOrders);
    const groups = groupItems(items);
    const arr = Array.from(groups.values());
    console.log(arr);
    arr.sort((a, b) => a.name.localeCompare(b.name));
    setItems(arr);
  }, [props.orders, props.selectedOrders, setItems]);
  return (
    <div className="p-4 border rounded-md shadow-md h-fit mt-4 xl:mx-12 w-full">
      <div className="flex items-center justify-between border-b-2 pb-2 mb-2">
        <div className="text-xl">Totals</div>
        <button
          title="print"
          className="text-indigo-600 hover:text-indigo-900"
          onClick={() => print("to-print", "html")}
        >
          <IconPrinter />
        </button>
      </div>
      <div id="to-print" className="xl:text-lg text-nowrap">
        {items.map((value, idx) => (
          <div
            key={`totals-${idx}`}
            className="flex items-center justify-between even:bg-slate-100 p-1"
          >
            <input
              id={`check-${value.id}`}
              type="checkbox"
              className="w-4 h-4 rounded-lg me-2"
            />

            <label htmlFor={`check-${value.id}`}>
              [{getGroupName(value.item_group_id)}] {value.name} ({value.count})
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

function groupItems(items) {
  const map = new Map();
  items.forEach((item) => {
    if (map.has(item.item_id)) {
      map.set(item.item_id, {
        id: item.item_id,
        count: map.get(item.item_id).count + item.item_count,
        item_group_id: item.item_group_id,
        name: item.item_name,
      });
    } else {
      map.set(item.item_id, {
        id: item.item_id,
        count: item.item_count,
        item_group_id: item.item_group_id,
        name: item.item_name,
      });
    }
  });
  return map;
}
function getItems(orders, selectedOrders) {
  if (selectedOrders.length > 0) {
    return selectedOrders.map((order) => order.items).flat();
  } else {
    return orders.map((order) => order.items).flat();
  }
}
export default Totals;
